module.exports = __webpack_public_path__ + "img/1.73a32098.png";